import React, { useEffect } from 'react'
import { useTexture } from '@react-three/drei'
import * as THREE from "three"
import { useSelector } from 'react-redux'
import {E_PedanaRivestimento, E_MainLato, E_GenereOmbrellone} from "../Utils/enumerations"

// genera il pavimento di copertura della pedana con i due diversi materiali
export default function Pavimento({lunghezza, larghezza, altezzaPedana}) { 
  const latoIngresso = useSelector(state => state.uiMainMenu.ingresso);   
  const rivestimento = useSelector(state => state.uiPedanaMenu.rivestimento);
  const hasRampa = useSelector(state => state.uiPedanaMenu.rampaDisabili);
  const dataOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.dataOmbrelloni);
  const ombrelloniIsVisible = useSelector(state => state.uiOmbrelloniMenu.isVisible);
  const genereOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.genereOmbrellone);
  const latoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.latoOmbrelloni);

  const shape = new THREE.Shape();

  const woodTexturesProps = useTexture({
    map: `${process.env.PUBLIC_URL}/textures/assiPavimento/PavimentoBasecolor.jpg`,
    normalMap: `${process.env.PUBLIC_URL}/textures/assiPavimento/PavimentoNormal.jpg`,
    roughnessMap: `${process.env.PUBLIC_URL}/textures/assiPavimento/PavimentoRoughness.jpg`,
    aoMap: `${process.env.PUBLIC_URL}/textures/assiPavimento/PavimentoAmbientOcclusion.jpg`,
    metalnessMap: `${process.env.PUBLIC_URL}/textures/assiPavimento/PavimentoMetallic.jpg`,
  })

  woodTexturesProps.map.repeat.set(0.65, 0.65);
  woodTexturesProps.normalMap.repeat.set(0.65, 0.65);
  woodTexturesProps.roughnessMap.repeat.set(0.65, 0.65);
  woodTexturesProps.aoMap.repeat.set(0.65, 0.65);
  woodTexturesProps.metalnessMap.repeat.set(0.65, 0.65);

  woodTexturesProps.map.wrapS = woodTexturesProps.map.wrapT = THREE.RepeatWrapping;
  woodTexturesProps.normalMap.wrapS = woodTexturesProps.normalMap.wrapT = THREE.RepeatWrapping;
  woodTexturesProps.roughnessMap.wrapS = woodTexturesProps.roughnessMap.wrapT = THREE.RepeatWrapping;
  woodTexturesProps.aoMap.wrapS = woodTexturesProps.aoMap.wrapT = THREE.RepeatWrapping;
  woodTexturesProps.metalnessMap.wrapS = woodTexturesProps.metalnessMap.wrapT = THREE.RepeatWrapping;

  const extrudeSettings = {
    steps: 2,
    depth: 0.02,
    bevelEnabled: true,
    bevelThickness: 0.005,
    bevelSize: 0.005,
    bevelOffset: -0.003,
    bevelSegments: 5,
  };

  // Calcola la forma dela pavimento a seconda della posizione della rampa disabili e della disposizione degli ombrelloni
  const generatePavimento = (conf) => {         
    if (conf === E_MainLato.Scegli.toString() || !hasRampa) {
      shape.moveTo(-lunghezza / 2, -larghezza / 2);
      shape.lineTo(lunghezza / 2, -larghezza / 2);
      shape.lineTo(lunghezza / 2, larghezza / 2);
      shape.lineTo(-lunghezza / 2, larghezza / 2);
      shape.lineTo(-lunghezza / 2, -larghezza / 2);
      return shape;
    }
    else if (conf === E_MainLato.Lato1.toString()) {
      // Decide la posizione in cui ricavare la rampa disabili 
      if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
        (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
        latoOmbrelloni.toString() === E_MainLato.Lato2.toString() && larghezza > dataOmbrelloni[0].secondaryDimension) {
          shape.moveTo(lunghezza / 2, larghezza / 2);
          shape.lineTo(-lunghezza / 2, larghezza / 2);
          shape.lineTo(-lunghezza / 2, larghezza/2 - dataOmbrelloni[0].secondaryDimension/2 + 0.5);
          shape.lineTo(-(lunghezza/2) + 1, larghezza/2 - dataOmbrelloni[0].secondaryDimension/2 + 0.5);
          shape.lineTo(-(lunghezza/2) + 1, larghezza/2 - dataOmbrelloni[0].secondaryDimension/2 - 0.5);
          shape.lineTo(-lunghezza / 2, larghezza/2 - dataOmbrelloni[0].secondaryDimension/2 - 0.5);
          shape.lineTo(-lunghezza / 2, -larghezza / 2);
          shape.lineTo(lunghezza / 2, -larghezza / 2);
          shape.lineTo(lunghezza / 2, larghezza / 2);
        } 
      else if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
        (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
        latoOmbrelloni.toString() === E_MainLato.Lato4.toString() && larghezza > dataOmbrelloni[0].secondaryDimension) {
          shape.moveTo(lunghezza / 2, larghezza / 2);
          shape.lineTo(-lunghezza / 2, larghezza / 2);
          shape.lineTo(-lunghezza / 2, -larghezza/2 + dataOmbrelloni[0].secondaryDimension/2 + 0.5);
          shape.lineTo(-(lunghezza/2) + 1, -larghezza/2 + dataOmbrelloni[0].secondaryDimension/2 + 0.5);
          shape.lineTo(-(lunghezza/2) + 1, -larghezza/2 + dataOmbrelloni[0].secondaryDimension/2 - 0.5);
          shape.lineTo(-lunghezza / 2, -larghezza/2 + dataOmbrelloni[0].secondaryDimension/2 - 0.5);
          shape.lineTo(-lunghezza / 2, -larghezza / 2);
          shape.lineTo(lunghezza / 2, -larghezza / 2);
          shape.lineTo(lunghezza / 2, larghezza / 2);
      }  
      else {
        shape.moveTo(lunghezza / 2, larghezza / 2);
        shape.lineTo(-lunghezza / 2, larghezza / 2);
        shape.lineTo(-lunghezza / 2, 0.5);
        shape.lineTo(-(lunghezza/2) + 1, 0.5);
        shape.lineTo(-(lunghezza/2) + 1, -0.5);
        shape.lineTo(-lunghezza / 2, -0.5);
        shape.lineTo(-lunghezza / 2, -larghezza / 2);
        shape.lineTo(lunghezza / 2, -larghezza / 2);
        shape.lineTo(lunghezza / 2, larghezza / 2);
      }    
      return shape;
    }
    else if (conf === E_MainLato.Lato2.toString()) {
      // Decide la posizione in cui ricavare la rampa disabili 
      if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
        (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
        latoOmbrelloni.toString() === E_MainLato.Lato1.toString() && lunghezza > dataOmbrelloni[0].secondaryDimension) {
          shape.moveTo(lunghezza / 2, -larghezza / 2);   
          shape.lineTo(lunghezza / 2, larghezza / 2); 
          shape.lineTo(-lunghezza/2 + dataOmbrelloni[0].secondaryDimension/2 + 0.5, larghezza / 2); 
          shape.lineTo(-lunghezza/2 + dataOmbrelloni[0].secondaryDimension/2 + 0.5, (larghezza / 2) - 1); 
          shape.lineTo(-lunghezza/2 + dataOmbrelloni[0].secondaryDimension/2 - 0.5, (larghezza / 2) - 1);
          shape.lineTo(-lunghezza/2 + dataOmbrelloni[0].secondaryDimension/2 - 0.5, larghezza / 2);
          shape.lineTo(-lunghezza / 2, larghezza / 2);   
          shape.lineTo(-lunghezza / 2, -larghezza / 2);   
      } 
      else if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
        (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
        latoOmbrelloni.toString() === E_MainLato.Lato3.toString() && lunghezza > dataOmbrelloni[0].secondaryDimension) {
          shape.moveTo(lunghezza / 2, -larghezza / 2);   
          shape.lineTo(lunghezza / 2, larghezza / 2); 
          shape.lineTo(lunghezza/2 - dataOmbrelloni[0].secondaryDimension/2 + 0.5, larghezza / 2); 
          shape.lineTo(lunghezza/2 - dataOmbrelloni[0].secondaryDimension/2 + 0.5, (larghezza / 2) - 1); 
          shape.lineTo(lunghezza/2 - dataOmbrelloni[0].secondaryDimension/2 - 0.5, (larghezza / 2) - 1);
          shape.lineTo(lunghezza/2 - dataOmbrelloni[0].secondaryDimension/2 - 0.5, larghezza / 2);
          shape.lineTo(-lunghezza / 2, larghezza / 2);   
          shape.lineTo(-lunghezza / 2, -larghezza / 2);   

      } else {
        shape.moveTo(lunghezza / 2, -larghezza / 2);   
        shape.lineTo(lunghezza / 2, larghezza / 2); 
        shape.lineTo(0.5, larghezza / 2); 
        shape.lineTo(0.5, (larghezza / 2) - 1); 
        shape.lineTo(-0.5, (larghezza / 2) - 1);
        shape.lineTo(-0.5, larghezza / 2);
        shape.lineTo(-lunghezza / 2, larghezza / 2);   
        shape.lineTo(-lunghezza / 2, -larghezza / 2);       
      }
      return shape;
    }
    else if (conf === E_MainLato.Lato3.toString()) {
      // Decide la posizione in cui ricavare la rampa disabili 
      if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
        (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
        latoOmbrelloni.toString() === E_MainLato.Lato2.toString() && larghezza > dataOmbrelloni[0].secondaryDimension) {
          shape.moveTo(lunghezza / 2, -larghezza / 2);
          shape.lineTo(lunghezza / 2, larghezza/2 - dataOmbrelloni[0].secondaryDimension/2 - 0.5);
          shape.lineTo((lunghezza/2) - 1, larghezza/2 - dataOmbrelloni[0].secondaryDimension/2 - 0.5);
          shape.lineTo((lunghezza/2) - 1, larghezza/2 - dataOmbrelloni[0].secondaryDimension/2 + 0.5);
          shape.lineTo(lunghezza / 2, larghezza/2 - dataOmbrelloni[0].secondaryDimension/2 + 0.5);
          shape.lineTo(lunghezza / 2, larghezza / 2);
          shape.lineTo(-lunghezza / 2, larghezza / 2);
          shape.lineTo(-lunghezza / 2, -larghezza / 2);
          shape.lineTo(lunghezza / 2, -larghezza / 2);
        } 
      else if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
        (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
        latoOmbrelloni.toString() === E_MainLato.Lato4.toString() && larghezza > dataOmbrelloni[0].secondaryDimension) {
          shape.moveTo(lunghezza / 2, -larghezza / 2);
          shape.lineTo(lunghezza / 2, -larghezza/2 + dataOmbrelloni[0].secondaryDimension/2 - 0.5);
          shape.lineTo((lunghezza/2) - 1, -larghezza/2 + dataOmbrelloni[0].secondaryDimension/2 - 0.5);
          shape.lineTo((lunghezza/2) - 1, -larghezza/2 + dataOmbrelloni[0].secondaryDimension/2 + 0.5);
          shape.lineTo(lunghezza / 2, -larghezza/2 + dataOmbrelloni[0].secondaryDimension/2 + 0.5);
          shape.lineTo(lunghezza / 2, larghezza / 2);
          shape.lineTo(-lunghezza / 2, larghezza / 2);
          shape.lineTo(-lunghezza / 2, -larghezza / 2);
          shape.lineTo(lunghezza / 2, -larghezza / 2);
      }  
      else {
        shape.moveTo(lunghezza / 2, -larghezza / 2);
        shape.lineTo(lunghezza / 2, -0.5);
        shape.lineTo((lunghezza/2) - 1, -0.5);
        shape.lineTo((lunghezza/2) - 1, 0.5);
        shape.lineTo(lunghezza / 2, 0.5);
        shape.lineTo(lunghezza / 2, larghezza / 2);
        shape.lineTo(-lunghezza / 2, larghezza / 2);
        shape.lineTo(-lunghezza / 2, -larghezza / 2);
        shape.lineTo(lunghezza / 2, -larghezza / 2);
      }    
      return shape;
    }   
    else if (conf === E_MainLato.Lato4.toString()) {
      // Decide la posizione in cui ricavare la rampa disabili 
      if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
        (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
        latoOmbrelloni.toString() === E_MainLato.Lato1.toString() && lunghezza > dataOmbrelloni[0].secondaryDimension) {
          shape.moveTo(-lunghezza / 2, -larghezza / 2);
          shape.lineTo(-lunghezza/2 + dataOmbrelloni[0].secondaryDimension/2 - 0.5, -larghezza / 2);
          shape.lineTo(-lunghezza/2 + dataOmbrelloni[0].secondaryDimension/2 - 0.5, (-larghezza / 2) + 1);
          shape.lineTo(-lunghezza/2 + dataOmbrelloni[0].secondaryDimension/2 + 0.5, (-larghezza / 2) + 1);
          shape.lineTo(-lunghezza/2 + dataOmbrelloni[0].secondaryDimension/2 + 0.5, -larghezza / 2);
          shape.lineTo(lunghezza / 2, -larghezza / 2);
          shape.lineTo(lunghezza / 2, larghezza / 2);
          shape.lineTo(-lunghezza / 2, larghezza / 2);
          shape.lineTo(-lunghezza / 2, -larghezza / 2);
      }
      else if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
        (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
        latoOmbrelloni.toString() === E_MainLato.Lato3.toString() && lunghezza > dataOmbrelloni[0].secondaryDimension) {
          shape.moveTo(-lunghezza / 2, -larghezza / 2);
          shape.lineTo(lunghezza/2 - dataOmbrelloni[0].secondaryDimension/2 - 0.5, -larghezza / 2);
          shape.lineTo(lunghezza/2 - dataOmbrelloni[0].secondaryDimension/2 - 0.5, (-larghezza / 2) + 1);
          shape.lineTo(lunghezza/2 - dataOmbrelloni[0].secondaryDimension/2 + 0.5, (-larghezza / 2) + 1);
          shape.lineTo(lunghezza/2 - dataOmbrelloni[0].secondaryDimension/2 + 0.5, -larghezza / 2);
          shape.lineTo(lunghezza / 2, -larghezza / 2);
          shape.lineTo(lunghezza / 2, larghezza / 2);
          shape.lineTo(-lunghezza / 2, larghezza / 2);
          shape.lineTo(-lunghezza / 2, -larghezza / 2);
      }
      else {
        shape.moveTo(-lunghezza / 2, -larghezza / 2);
        shape.lineTo(-0.5, -larghezza / 2);
        shape.lineTo(-0.5, (-larghezza / 2) + 1);
        shape.lineTo(0.5, (-larghezza / 2) + 1);
        shape.lineTo(0.5, -larghezza / 2);
        shape.lineTo(lunghezza / 2, -larghezza / 2);
        shape.lineTo(lunghezza / 2, larghezza / 2);
        shape.lineTo(-lunghezza / 2, larghezza / 2);
        shape.lineTo(-lunghezza / 2, -larghezza / 2);
      }
      return shape;
    }
    else {
      shape.moveTo(-larghezza / 2, -lunghezza / 2);
      shape.lineTo(larghezza / 2, -lunghezza / 2);
      shape.lineTo(larghezza / 2, lunghezza / 2);
      shape.lineTo(-larghezza / 2, lunghezza / 2);
      shape.lineTo(-larghezza / 2, -lunghezza / 2);
      return shape;
    }
  }

  useEffect(() => {
    generatePavimento(latoIngresso);  
  }, [lunghezza, larghezza, altezzaPedana, latoIngresso]);

  return (
      <mesh position={[0, altezzaPedana, 0]} rotation={[-Math.PI / 2, 0, 0]}>
        <extrudeGeometry args={[generatePavimento(latoIngresso), extrudeSettings]} />
        {rivestimento === E_PedanaRivestimento.WPC.toString() ? 
          <meshStandardMaterial {...woodTexturesProps} /> :
          <meshStandardMaterial {...woodTexturesProps} color={0xaa8888}/>} 
      </mesh>
  )
}
